import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', public: true }
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '工作台', icon: 'el-icon-s-home' }
      },
      {
        path: 'freight-route',
        name: 'FreightRoute',
        component: () => import('@/views/freightRoute/index.vue'),
        meta: { title: '线路运价', icon: 'el-icon-map-location' }
      },
      {
        path: 'value-added-service',
        name: 'ValueAddedService',
        component: () => import('@/views/valueAddedService/index.vue'),
        meta: { title: '增值服务', icon: 'el-icon-coin' }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/orders/index.vue'),
        meta: { title: '订单列表', icon: 'el-icon-document' }
      },
      {
        path: 'scx-orders',
        name: 'ScxOrders',
        component: () => import('@/views/scxOrders/index.vue'),
        meta: { title: '订单列表-易宠运', icon: 'el-icon-tickets' }
      },
      {
        path: 'car-leads',
        name: 'CarLeads',
        component: () => import('@/views/leads/index.vue'),
        meta: { title: '汽车报价线索', icon: 'el-icon-phone-outline' }
      },
      {
        path: 'promo-platform',
        name: 'PromoPlatform',
        component: () => import('@/views/promoPlatform/index.vue'),
        meta: { title: '推广平台管理', icon: 'el-icon-share' }
      },
      {
        path: 'promo-rebate-bill',
        name: 'PromoRebateBill',
        component: () => import('@/views/promoRebateBill/index.vue'),
        meta: { title: '推广账单', icon: 'el-icon-wallet' }
      },
      {
        path: 'system/role',
        name: 'SystemRole',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'system/menu',
        name: 'SystemMenu',
        component: () => import('@/views/system/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      },
      {
        path: 'system/role-menu',
        name: 'SystemRoleMenu',
        component: () => import('@/views/system/roleMenu/index.vue'),
        meta: { title: '权限管理', icon: 'el-icon-key' }
      },
      {
        path: 'system/user',
        name: 'SystemUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user-solid' }
      }
    ]
  },
  { path: '/pricing', redirect: '/freight-route' },
  { path: '*', redirect: '/dashboard' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const appTitle = process.env.VUE_APP_TITLE || '送骑侠'
  document.title = to.meta.title ? `${to.meta.title} - ${appTitle}` : `${appTitle}管理后台`

  if (to.meta.public) {
    if (to.name === 'Login' && store.getters['user/isLoggedIn']) {
      next({ path: store.getters['user/defaultHomePath'] })
    } else {
      next()
    }
    return
  }

  if (!store.getters['user/isLoggedIn']) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  if (!store.state.user.menus || store.state.user.menus.length === 0) {
    try {
      await store.dispatch('user/fetchMenus')
    } catch (e) {
      store.dispatch('user/logout')
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }

  const menuPaths = store.getters['user/menuPaths']
  const isRedirectRoute = to.matched.some((r) => r.redirect)
  if (!isRedirectRoute && menuPaths.length > 0 && !menuPaths.includes(to.path)) {
    next(menuPaths[0] || store.getters['user/defaultHomePath'])
    return
  }

  next()
})

export default router
